import React from "react";
import { Files } from "assets";
import { Image } from "semantic-ui-react";

const getIconFromExtension = (extension) => {
  const ext = extension.toLowerCase().replace(".", "");
  switch (ext) {
    case "doc":
    case "docx":
      return Files.Doc;

    case "pdf":
      return Files.Pdf;

    case "ppt":
    case "pptx":
      return Files.Ppt;

    case "xls":
    case "xlsx":
    case "xltx":
      return Files.Xls;

    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
      return Files.Image;

    default:
      return Files.File;
  }
};

const getFileExtension = (fileName) => {
  const result = /.*\.([a-zA-Z0-9]+)$/.exec(fileName);

  if (Array.isArray(result) && result.length > 1) {
    return result[1];
  }
  return "";
};

const FileIcon = ({ fileName, extension }) => {
  let ext = extension;
  if (!!fileName && !ext) {
    ext = getFileExtension(fileName);
  }
  return <Image src={getIconFromExtension(ext ?? "")} />;
};
export default FileIcon;
